import { getSiteAccess } from "@imaios-js/utils";
import jsonRoutes from "../../../public/js/fos_js_routes.json";
import { Routing } from '../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/js/router';

Routing.setRoutingData(jsonRoutes);

export function getFosJsRoutingUrlWithSiteaccess(routeName, jsonParameters) {
    let prefix = '';
    const siteaccess = getSiteAccess();
    if (siteaccess.length > 0) {
        prefix = '/' + siteaccess;
    }

    return prefix + Routing.generate(routeName, jsonParameters)
}

window.imaiosRouting = {
    getFosJsRoutingUrlWithSiteaccess
};
